<template>
  <div>
    <!-- To correctly filter the display of stuff, based on roles (project or referential) it must be verified prior to deployement -->
      <!-- Display for sharing project + other if needed -->
    <div class="project-code-actions">
      <div class="project-header-code" v-if="selectedProject === 0">
        <input class="project-insert" type="text" placeholder="Veuillez entrer le code d'un projet">
        <button type="submit" class="project-code-button" @click="sendCode()">Essayer le code</button>
        <div class="project-answer" v-if="sharecode">
          {{ sharecode.message }}
        </div>
      </div>
        <!-- <div>
          <button class="btn filter-toggle-btn" @click="showArchived = !showArchived">
            {{ showArchived ? 'Masquer les projets archivés' : 'Afficher les projets archivés' }}
          </button>
        </div> -->
        <div class="action-buttons" v-if="!displayAnswerPage">
          <!-- <button v-if="selectedProject > 0" @click="resetProject" class="back-button">Retour</button> -->
          <button v-if="selectedProject == 0" @click="createProjectModalOpen" class="create-button">Nouveau</button>
          <button v-if="!selectedProject" class="create-button" @click="showArchived = !showArchived">
            {{ showArchived ? 'Projets actifs' : 'Projets archivés' }}
          </button>
          <!-- <button class="create-button" v-if="referentialDisplay" @click="showManageToggle">
            {{ showManaged? 'Propres Projets' : 'Gestion Projets' }}
          </button> -->
        </div>
      </div>
      
      <!-- En-tête de la liste des projets -->
    <div class="project-header" v-if="selectedProject === 0">
      <div class="title-col" @click="sortBy('title')">Titre <i class="bi bi-filter"></i></div>
          <div class="description-col">Description</div>
          <div class="status-col">
          <select v-model="filters.status" class="header-filter-select">
              <option
                  v-for="option in statusOptionsToShow"
                  :key="option.value"
                  :value="option.value"
              >
                  {{ option.label }}
              </option>
            </select>
          </div>
          <div class="date-col" @click="sortBy('creation_date')">Créé le <i class="bi bi-filter"></i></div>
          <div v-if="!showArchived" class="date-col" @click="sortBy('modification_date')">Modifié le <i class="bi bi-filter"></i></div>
          <div v-if="showArchived" class="date-col" @click="sortBy('modification_date')">Effacé le <i class="bi bi-filter"></i></div>
      </div>
      
      <!-- Liste des projets -->
    <div v-if="!displayProjectList || selectedProject == 0">
      <div 
        v-for="group in groupedProjects" 
        :key="group.referential_id" 
        class="referential-group"
        >
        <h2 class="referential-group-title" :title="group.referential_id"  @click="(e) => crunchChildren(e, group)">{{ group.referential_title }}</h2>
        <div v-show="!(group.projects[0] && group.projects[0].collapsed)">
            <div
                v-for="project in group.projects" 
                :key="project.project_id" 
                class="project-item"
                :style="getProjectClasses(project)"
                @click="handleProjectClick(project.project_id)"
            >
                <!-- <div class="id-col">{{ project.project_id }}</div> -->
                <div class="title-col" :title="project.title">{{ project.title }}</div>
                <div class="description-col" :title="project.description">{{ project.description }}</div>
                <!-- referentiel id to know where you at (might need the referentiel_id ?) -->
                <!-- <div class="referential-col">{{ getReferentialTitle(project.referential_id)}}</div> -->
                <div v-if="selectedProject == 0" class="status-col">{{ getStatusLabel(project.status) }}</div>
                <div v-if="selectedProject == 0" class="user-col" :title="project.created_by_username">{{ formatDate(project.creation_date) }}</div>
                <div v-if="selectedProject == 0" class="date-col" :title="project.modified_by_username">{{ formatDate(project.modification_date) }}</div>
                <div class="actions-col" v-if="selectedProject > 0">
                    <button 
                      v-if="project.PC"
                      @click.stop="editProject(project)" 
                      title="Editer le projet" 
                      class="btn btn-icon"
                      ><i class="bi bi-pencil-fill"></i></button>
                    <button 
                      v-if="project?.is_owner && project.status === 'ARCHIVE' && !project.has_evaluator"
                      @click.stop="deleteProject(project.project_id)" 
                      title="Supprimer le projet" 
                      class="btn btn-icon"
                      ><i class="bi bi-trash3-fill"></i></button>
                    <button 
                      v-if="project.PC && project.status !== 'ARCHIVE'"
                      @click.stop="changeProjectStatus('ARCHIVE')" 
                      title="Archiver le projet" 
                      class="btn btn-icon"
                      ><i class="bi bi-trash3-fill"></i></button>
                      <button 
                      v-if="project.PC && project.status === 'ARCHIVE' && !project.has_evaluator"
                      @click.stop="changeProjectStatus('EDITING')" 
                      title="Restaurer projet" 
                      class="btn btn-icon"
                      ><i class="bi bi-rewind"></i></button>
                    <button 
                      @click.stop="duplicateProject(project.project_id)" 
                      title="Dupliquer le projet" 
                      class="btn btn-icon"
                      ><i class="bi bi-copy"></i></button>
                    <button 
                      v-if="false"
                      @click.stop="variantProject(project.project_id)" 
                      title="Créer une variante" 
                      class="btn btn-icon"
                      ><i class="bi bi-diagram-2-fill"></i></button>
                      <!-- <button
                      @click.stop="createPDF()"
                      title="Génerer rapport (PDF)"
                      class="btn btn-icon"
                      ><i class="bi bi-box-arrow-up"></i></button> -->
                    <div v-if="selectedProject > 0 && (project.PE || project.PC)" class="action-buttons">
                      <button v-if="project.status === 'EDITING' && selectedProject > 0 && project.PC" @click.stop.prevent="changeProjectStatus('VALIDATION')" class="create-button">Mise en évaluation</button>
                      <button v-if="project.status === 'VALIDATION' && selectedProject > 0 && project.PE" @click.stop.prevent="changeProjectStatus('EDITING')" class="create-button">Remise en édition</button>
                      <button v-if="project.status === 'VALIDATION' && selectedProject > 0 && project.PE" @click.stop.prevent="changeProjectStatus('VALIDATED')" class="create-button">Valider projet</button>
                      <!-- <button v-if="selectedProject > 0" @click.stop.prevent="changeProjectStatus('ARCHIVE')" class="create-button">Archiver</button> -->
                    </div>
                </div>
                
            </div>
          </div>
        </div>
      </div>
      
      <div v-if="!displayAnswerPage && selectedProject > 0 " class="project-detail-container">
        <div class="filterQ">
        <label class="filter-label" v-if="this.answerQTest.length>0 ">
          <input type="checkbox" :checked="filterBlackQuestionsActive" @change="toggleFilter">Afficher uniquement les questions d’exclusion
        </label>
        <label class="filter-label" v-if="this.answerQTest.length>0 ">
        <input type="checkbox" :checked="filterUnAnsweredQuestionsActive" @change="toggleFilter2">Afficher uniquement les questions non-répondues
        </label>
        <!-- <button @click.stop="createPDF()">Génerer pdf</button> -->
      </div>
      <!-- ! DO THE WHITE FILTER !
      <div v-if="!displayAnswerPage2 && selectedProject > 0 " class="project-detail-container">
      <div class="filterQ">
        <label class="filter-label">
          <input type="checkbox" :checked="filterWhiteQuestionsActive" @change="toggleFilter2">Afficher uniquement les critères/questions d’non répondues
        </label>
      </div>
    </div> -->
          <AnswerPage
              id="element-to-print"
              :children="fetchRootCriteria(selectedProject)"
              :level="0"
              :filter-is-active="filterBlackQuestionsActive || filterUnAnsweredQuestionsActive"
          />
    </div>

      <!-- Boutons d'action -->
      <!-- <div class="action-buttons" v-if="!displayAnswerPage">
          <button v-if="selectedProject > 0" @click="resetProject" class="back-button">Retour</button>
          <button v-if="selectedProject == 0" @click="createProjectModalOpen" class="create-button">Nouveau</button>
      </div> -->
      
      <!-- Composants modaux (à implémenter ultérieurement) -->
      <ProjectModalCreator v-if="canEditList.projectModalOpen" />
      <ConfirmationDialog v-if="canEditList.confirmationDialogOpen" />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import '../../assets/styles/base.css'
import '../../assets/styles/multiselect.css'
import ConfirmationDialog from '../generic/ConfirmationDialog.vue' 
import ProjectModalCreator from './ProjectModalCreator.vue'
import AnswerPage from './AnswerPage.vue'
/* import CriteriaQuestionDisplay from './CriteriaQuestionDisplay.vue' */
//import Multiselect from 'vue-multiselect'
//import ReferentialTreeEditor from '../admin/ReferentialTreeEditor.vue'

export default {
  name: "ProjectEditor",

  components: {
  //    ReferentialTreeEditor,
      //Multiselect,
      AnswerPage,
      ConfirmationDialog, 
      ProjectModalCreator,
  },
  props: {
      displayAnswerPage: {
        type: Boolean,
        default: false
      },
      displayProjectList: {
        type: Boolean,
        default: true
      }
  },
  data() {
      return {
          filters: {
              title: "",
              status: ""
          },
          statusOptions: [
          { value: '', label: 'Status' },
          { value: 'EDITING', label: 'Edition' },
          { value: 'VALIDATION', label: 'En validation' },
          { value: 'VALIDATED', label: 'Validé' },
          { value: 'ARCHIVE', label: 'Archivé' }
        ],
          sortField: "id",
          sortDirection: "asc",
          showFilters: false,
          code: "",
          showArchived: false,
          isGeneratingPDF:false,
          showManaged: false,
       }
  },
  computed: {
      ...mapState("project", ["projectData", "selectedProject", "canEditList", "loading", "questionTree", "referential_id", "answerQ", "answerQTest", "evaluationCriteriaColor", "sharecode", "filterBlackQuestionsActive", "filterUnAnsweredQuestionsActive", "files", "file", "roles"]),
      ...mapState("auth", ["user_id", 'referentialDisplay']),
      ...mapState("referential", ["selectedReferential", "referentialData"]),
      ...mapGetters("project", [/* "isProjectLocked", */ "formatDate", "fetchRootCriteria", "readOnlyProject"]),
    
    statusOptionsToShow(){
        if(!this.showArchived){
          //console.log("!this.showArchived, HERE'S YOUR STATUSOPTIONS :", this.statusOptions)
            return this.statusOptions.filter(opt => opt.value !== 'ARCHIVE');
        }else{
          //console.log("else, HERE'S YOUR STATUSOPTIONS :", this.statusOptions)
          this.filters.status === 'ARCHIVE';
          return this.statusOptions.filter(opt => opt.value === 'ARCHIVE');
        }
    },       
    filterIsActive: {
    get() {
      return this.filterBlackQuestionsActive
    },
    set(value) {
      this.$store.commit('project/toggleBlackQuestionsFilter', value)
      }
      },

      baseFilteredProjectData() {
          return this.projectData.filter(
              proj => this.selectedProject === 0 || this.selectedProject == proj.project_id
          )
      },
      filteredSortedProjects() {
          let filtered = this.baseFilteredProjectData
          
              if (this.filters.title) {
                  filtered = filtered.filter(proj => 
                      proj.title.toLowerCase().includes(this.filters.title.toLowerCase())
                  )
              }
              
              if (this.filters.status) {
                  filtered = filtered.filter(proj => 
                      proj.status === this.filters.status
                  )
              }
              
              return [...filtered].sort((a, b) => {
                  switch (this.sortField) {
                      case "id":
                          return this.sortDirection === "asc" 
                              ? a.project_id - b.project_id
                              : b.project_id - a.project_id
                      case "title":
                          return this.sortDirection === "asc"
                              ? a.title.localeCompare(b.title)
                              : b.title.localeCompare(a.title)
                      case "status":
                          return this.sortDirection === "asc"
                              ? a.status.localeCompare(b.status)
                              : b.status.localeCompare(a.status)
                      case "creation_date":
                          return this.sortDirection === "asc"
                              ? new Date(a.creation_date) - new Date(b.creation_date)
                              : new Date(b.creation_date) - new Date(a.creation_date)
                      case "modification_date":
                          return this.sortDirection === "asc"
                              ? new Date(a.modification_date) - new Date(b.modification_date)
                              : new Date(b.modification_date) - new Date(a.modification_date)
                      default:
                          return a.project_id - b.project_id
                        }
                })
      },
      groupedProjects() {
        const projects = this.filteredSortedProjects
        if(projects.length === 0) {
            return []
        }
        const groups = {}

        projects.forEach(project => {
          if(!this.showArchived && project.status === 'ARCHIVE' && this.selectedProject == 0 ){
            // //console.log("skipping archived project in list view")
            return
          } else if((this.showArchived && project.status !== 'ARCHIVE' || !(project.PC || project.PE)) && this.selectedProject == 0){
            // //console.log("skipping non archived project in archived view because showArchived is true", this.showArchived)
            /*
            write logic here.
            if it show archived and project is not archived, skip it
            if it show archived and user is not PC or PE, skip itj
            */
            return
          }
          // //console.log("including project in list view", project)
          // if(project.status === 'ARCHIVE' && this.selectedProject == 0){
          //   // //console.log("skipping archived project in list view")
          //   return
          // }
          const refId = project.referential_id
          if(!groups[refId]){
            groups[refId]= {
              referential_id : refId,
              referential_title: project.referential_name || `Référentiel #${refId}`,
              projects: []
            }
          }
          groups[refId].projects.push(project)
        })
        ////console.log("Grouped projects:", groups)
        return Object.values(groups)
      },
      currentProject() {
            return this.projectData.find(p => p.project_id === this.selectedProject)
      },
    },
    async mounted() {
      this.$store.commit("project/loadingMutation", true);
      if(!this.projectData || this.projectData.length <= 0){
        await this.$store.dispatch("project/fetchProjectList")
        this.$store.dispatch("referential/fetchReferentialList")
            .catch(error => console.error("Error fetching project data:", error))
          }
          this.$store.commit("project/loadingMutation", false);
        /* this.$store.dispatch("project/fetchAnswers", {id : this.$route.params.id}) */
         if (this.selectedProject>0) {
          this.$store.dispatch('project/getAllFiles')
        }
      this.checkRouteParams()
      // reset selected referential
      this.$store.commit("referential/selectTreeMutation", 0)
    },
    watch: {
      '$route.params.id': 'checkRouteParams',
      selectedProject(newVal, oldVal) {
          if (newVal !== oldVal) {
            //console.log("MODIFICATION INCOMING")
              this.$store.dispatch("project/getAllFiles").catch(err => console.error('getAllFiles failed', err))
          }
      },
      showArchived(){
          if(this.showArchived && this.filters.status !== "ARCHIVE")return this.filters.status = 'ARCHIVE';
          else return this.filters.status = ''
      }
    },
    methods: {
      getStatusLabel(status){
        if (!this.statusOptions) {
          return status
        }
        const optionValue = this.statusOptions.find(opt => opt.value === status)
        return optionValue ? optionValue.label : status
      },
      getReferentialTitle(id){
        if(!id) {return ''}
          if(this.referentialData.length === 0){return `Titre introuvable pour l'id ${id}`}
          const referential = this.referentialData.find(r => r.referentiel_id === id)
        if(referential){
          return referential.title
        }else{
          return `Titre introuvable pour l'id ${id}`
        }
      },
      toggleFilter() {
        this.$store.commit("project/toggleBlackQuestionsFilter")
      },
      toggleFilter2(){
        this.$store.commit("project/toggleUnAnsweredQuestionsActive")
      },
      async checkRouteParams() {
          const routeId = this.$route.params.id
          //console.log("routeId : ",routeId)
          if (routeId) {
            try {
                const projectId = parseInt(routeId)
                const project = this.projectData.find(p => p.project_id === projectId)

                if (project) {
                  if(projectId){
                      await this.$store.dispatch("project/fetchProjectCriteriaList", { id: projectId })
                      await this.$store.dispatch("project/fetchAllAnswers", { id: projectId })
                      await this.$store.commit("project/selectProjectMutation", projectId)
                    }
                    await this.$store.dispatch("project/getProjectRights")
                    this.$store.dispatch('project/getAllFiles')
                } else {
                    console.error("Project not found in the existing list: ", projectId)
                }
            } catch (error) {
                console.error("Error in checkRouteParams: ", error)
            }
        } else {
            this.$store.commit("project/selectProjectMutation", 0)
        }
      },
      handleProjectClick(id) {
          if (this.loading) return

          if (this.selectedProject === id) {
              this.resetProject()
              this.$router.push('/project')
          } else {
              this.$router.push(`/project/${id}/generalData`)
          }
      },
      /* resetProject() {
        this.$store.commit("project/selectProjectMutation", 0)
        this.resetFilters()
      }, */
      createProjectModalOpen() {
          if(this.selectedProject == 0) {
              this.$store.commit("referential/selectTreeMutation", 0)
              this.$store.commit("project/toggleProjectModalNew", true)
          } 
      },
      editProject() {
        this.$store.commit("project/toggleProjectModalNew", true)
      },
      deleteProject(projectId) {
          this.$store.commit("project/returnConfirmationObjectMutation", { 
              id: projectId, 
              type: "delete-project",
              title: "Suppression",
              message: "Êtes-vous sûr de vouloir supprimer ce projet?"
          })
      },
      variantProject(projectId){
        if(this.selectedProject == 0) {
              this.$store.commit("project/selectProjectMutation", 0)
              this.$store.commit("project/toggleProjectModalNew", true)
          }
        this.$store.commit("project/returnConfirmationObjectMutation", { 
              id: projectId, 
              type: "variant-project",
              title: "Variante",
              message: "Êtes-vous sûr de vouloir faire une variante de ce projet ?",
              create_variant: this.selectedProject,
              new_version: this.projectData.find(p => p.project_id === projectId).version,
          })
      },
      duplicateProject(projectId) {
          this.$store.commit("project/returnConfirmationObjectMutation", { 
              id: projectId, 
              type: "duplicate-project",
              title: "Duplication",
              message: "Êtes-vous sûr de vouloir dupliquer ce projet?"
          })
      },
      changeProjectStatus(status) {
            let title = ""
            let message = ""
            switch(status) {
                case "VALIDATION":
                    title = "Mise en évaluation"
                    message = "Êtes-vous sûr de vouloir mettre ce projet en évaluation ?<br>L'envoi du rapport pour évaluation vaut pour engagement au respect des informations fournies.<br>Une fois la demande d'évaluation effectuée ces dernières ne pourront plus être modifiées.<br>Merci de suivre l'évolution de la démarche dans l'onglet 'Suivi de l'évaluation'.<br>Un rapport d'évaluation ainsi qu'une notification vous parviendra une fois l'évaluation finalisée"
                    break
                case "VALIDATED":
                    title = "Valider Projet"
                    message = "Êtes-vous sûr de vouloir valider ce projet ?"
                    break
                case "ARCHIVE":
                    title = "Archiver"
                    message = "Êtes-vous sûr de vouloir archiver ce projet ?"
                    break
                default:
                    title = "Remise en édition"
                    message = "Êtes-vous sûr de vouloir remettre ce projet en édition ?"
                    break
            }
            this.$store.commit("project/returnConfirmationObjectMutation", { 
                id: this.selectedProject, 
                type: "project-change-status",
                title: title,
                message: message,
                newStatus: status,
                status: this.releaseStatus,
            })
            //console.log(`Demande de changement de statut de '${this.releaseStatus}' vers '${status}'`)
        },
      sortBy(field) {
          if (this.sortField === field) {
              this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc'
          } else {
              this.sortField = field
              this.sortDirection = 'asc'
          }
      },
      toggleFilterView() {
          this.showFilters = !this.showFilters
      },
      /* resetFilters() {
          this.filters.title = ""
          this.filters.status = ""
          this.sortField = "id"
          this.sortDirection = "asc"
          this.$router.push('/project')
      }, */
      async sendCode(){
        const code = document.querySelector('.project-insert').value
        const payload = {
          code: code,
        }
          await this.$store.dispatch('project/shareProject', {payload})
            .catch(error => {
              console.error("Error :", error)
              const errorMessage = {message :"Ce code ne fonctionne pas ou n'existe pas."}
              this.$store.commit("project/shareProjectMutation", errorMessage)
            })
            if(this.sharecode.result){
              this.sharecode.message= "Code fonctionnel"
              //console.log("I'm in")
              location.reload();
            }else{
              //console.log("I'm out")
              this.sharecode.message="Code invalide"
            }
      },
      getProjectClasses(project) {
        let result = 0
        if(project){
          if(!project?.is_owner && project.PE){
              result = 3
          }else if (project?.is_owner && project.is_shared){
          result = 1
          }else if(project?.is_owner && !project.is_shared){
            result = 0
          }else if (!project?.is_owner && project.is_shared){
            result = 2
          }
        }
        const colorValue = {
          0:'var(--project-owner)',
          1:'var(--project-owner-shared)',
          2:'var(--project-collaborator)',
          3:'var(--project-evaluator)',
        };
        if (colorValue != undefined){
          return {
          '--project-color': colorValue[result],
          } 
        }
      },
      showManageToggle(){
        this.showManaged = !this.showManaged
        //console.log("showManaged is now :", this.showManaged)
        //console.log('referentialDisplay', this.referentialDisplay)
        if(this.showManaged) {
          // this.$store.commit("project/selectProjectMutation", 0)
          // this.$router.push('/project')
        }
      },
      crunchChildren(event, referential) {
        //console.log("event", event, "\nreferential :", referential)
            if (!referential) return
            if (event.target.closest('.referential-group-title')) {
                this.$store.commit("project/collapseReferentialMutation", referential)
            }
        },
  },
}

</script>

<style scoped>
/* grid */
.project-header,
.project-item,
.project-filter{
  display: grid;
  grid-template-columns: 15% 35% 16% 17% 18%  ;
  /* grid-template-columns: 9% 39% 0% 21% 15% 16%; */
  width: 100%;
  align-items: center;
}
.project-filter{
  grid-template-columns: 60% 40%;
}

/* .project-owner {
    border-left: 7px solid #979797;
}
.project-owner-shared {
    border-left: 7px solid #aebde7;
}
.project-collaborator {
    border-left: 7px solid #f58a93;
} */

.project-header {
  grid-template-columns:15% 35% 16% 17% 17%;
  font-weight: bold;
  padding: 12px 15px;
  border-radius: var(--border-radius);
  margin-bottom: 2vh;
  padding: 20px 14px;
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05); */
  overflow: hidden;
  top: 0;
}

.project-header:hover, 
.project-header:hover .header-filter-select {
    background-color: var(--hover-bg);
    transition: all 0.5s ease-out;
    outline: none;
}

.project-header > div {
  cursor: pointer;
  user-select: none;
  position: relative;
}

.project-header > div:hover {
  color: var(--primary-color);
  transition: var(--transition);
}

.project-header > div i {
  margin-left: 5px;
}

.status-cols, .date-cols, .user-cols {
  display: grid;
  grid-template-columns: 33% 44% 23%;
  width: 100%;
}

/* column styles */
.id-col, .title-col, .description-col,.referential-col, .status-col, .status2-col, .date-col, .user-col, .actions-col {
  padding: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.project-item:has(.actions-col) {
    grid-template-columns: 25% 50% 25% ;
    background-color: none;
}

.id-col {
  text-align: center;
  font-weight: 500;
}

/* filter style */
.project-filter {
  padding: 12px 15px;
  margin-bottom: 15px;
  background-color: #f8f9fa;
  border-radius: var(--border-radius);
  border: 1px solid var(--border-color);
}

.filter-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: var(--border-radius);
  font-size: 14px;
  transition: border-color 0.2s;
}

.filter-input:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px var(--primary-light);
}

.filter-select {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: var(--border-radius);
  background-color: white;
  cursor: pointer;
  width: 100%;
}

/* Status header select */
.status-header {
  display: flex;
  align-items: center;
  position: relative;
}

.header-filter-select {
    padding: 2px 6px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    width: 130px;
    height: 35px;
    border: none;
}

/* project list */
.project-list {
  /* border: 1px solid var(--border-color);
  background-color: #f8f9fa; */
  padding:8px;
  border-radius: var(--border-radius);
  overflow: hidden;
}

.project-item {
  padding: 20px 14px;
  border-radius: 12px;
  cursor: pointer;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
  border: 1.8px solid var(--project-color);
  border-left: 1.8px solid var(--project-color);
}

.project-item:hover {
  background-color: var(--hover-bg);
  /* transition: color 0.4s linear; */
  border: 1.8px solid var(--project-color);
  transition: all 0.13s ease-out ;
  border-left: 8px solid var(--project-color);
}
/* 
.project-detail-container {
  margin: 20px 0;
  padding: 20px;
  background-color: white;
  border-radius: var(--border-radius);
  border: 1px solid var(--border-color);
}
 */
/* buttons */
.action-buttons, .filter-toggle {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

.filter-toggle-btn{
  background-color: var(--primary-light);
  color: var(--primary-color);
  border: none;
  font-size: 1rem;
}

.filter-toggle-btn:hover{
  background-color: var(--primary-color);
  color: var(--bg-color);
  border: var(--bg-color);
}

.btn {
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  cursor: pointer;
  transition: all 0.2s;
  font-weight: 500;
}

.btn-icon {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 18px;
  padding: 0;
  margin: 0 2px;
  background-color: var(--hover-bg);
  color: var(--text-color);
}

.btn-icon:hover {
  color: var(--primary-color);
}

.actions-col {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 3vw;
  gap: 2px;
}

.project-item.locked {
  opacity: 0.75;
}

.project-code-actions{
    width: 100%;
    display: flex;
    text-align: center;
    margin: auto;
    justify-content: center;
}

.project-code-button{
  display: flex;
  align-items: center;
  padding: 10px 16px;
  border-radius: var(--border-radius);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
  background-color: var(--hover-bg);
  color: var(--text-color);
}

.project-code-button:hover{
  background-color:#e3e3e3;
  color: #2d2d2d;
  transition: var(--transition);
}

.project-header-code {
    display: flex;
    align-items: center;
    gap: 1rem; 
    padding: 1rem;
    border-radius: 8px;
    /* max-width: 24.4vw; */
    max-width: 26vw;
    min-width:23.4vw;
    /* margin: auto; */
    text-align: center;
}

.project-insert {
    flex-grow: 1;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    padding: 0.75rem 1rem;
}

.project-answer {
    padding: 0.75rem 1rem;
    border-radius: 6px;
    font-weight: 500;
    font-size: 0.9rem;
    display: flex;
    align-items: center;
}

.referential-group {
  margin-bottom: 30px;
}

.referential-group-title {
  font-size: 1.5em;
  font-weight: bold;
  color: var(--primary-color);
  padding-bottom: 10px;
  border-bottom: 2px solid var(--primary-light);
  margin-bottom: 15px;
}

:deep(.multiselect__option--selected.multiselect__option--highlight, .multiselect__option--selected.multiselect__option--highlight::after) {
  /* background: #ff6a6a; */
  color: var(--primary-color);
}
:deep(.multiselect__option--highlight, .multiselect__option--highlight::after) {
  /* background: var(--primary-color); */
  outline: none;
  color: #5e4545;
}
:deep(.multiselect__content-wrapper){
  min-width: 100%;
}

/* :deep(.multiselect__tags){
  min-width: 324%;
} */
:deep(.multiselect__option--selected) {
  background: #f3f3f3;
  color: #35495e;
  font-weight: bold;
}


.status-col {
    overflow: hidden;
}

#element-to-print {
  background-color: white; /* Fond blanc pour être sûr */
  color: black; /* Texte noir par défaut */
}

/* On force des couleurs "en dur" pour les titres et textes importants */
#element-to-print .project-title {
  font-size: 18px;
  font-weight: bold;
  color: #1a202c; /* Remplacez var(--text-color) par une couleur hexadécimale */
}

#element-to-print .project-reference {
  font-size: 14px;
  font-weight: 600;
  color: #4a5568;
  background-color: #f7fafc;
  border: 1px solid #e2e8f0;
}

#element-to-print .q-description {
    color: #2d3748;
}

/* Assurez-vous que les bordures utilisent aussi des couleurs fixes */
#element-to-print .project-container {
    border: 1px solid #cbd5e0; /* Remplacez var(--project-border-color) */
}
</style>